import UserChatBubble from "../../Components/Forms/FirmUserBtn";

export default function FlaggedStaff({ staff }) {
  if (!staff.first_name && !staff.last_name) return <span className="text-muted">—</span>;
  return (
    <UserChatBubble
      userId={staff.user_id}
      first_name={staff.first_name || ""}
      last_name={staff.last_name || ""}
      profilePic={staff.profile_pic_url}
      is_active={staff.is_active}
      hideIcon
      equalizeNameWidths={false}
      width={19}
    />
  );
}
